import * as React from "react"
import * as Immutable from 'immutable'
import { RentalAdvert, SprocketAsset, RoutesOutput, VerifiedAspect } from "../../types/types";
import CrumbTrail from "../shared/advert/CrumbTrail";
import { AdvertiserInfo } from "../shared/advert/AdvertiserInfo";
import Interior from "./components/Interior";
import Surroundings from "./components/Surroundings";
import Skiing from "../shared/advert/Skiing";
import Culture from "./components/Culture";
import Activities from "./components/Activities";
import Remarks from "./components/Remarks";
import Youtube from "../shared/advert/Youtube";
import BnbRoom from "./components/BnbRoom";
import { ContentMapType } from "../shared/advert/ContentMap";
import PricingInfo from "./components/PricingInfo";
import { CoronaPolicy } from "./components/CoronaPolicy";
import { Routes } from "../../api/queries/rental/content";
import { Action, AsyncState } from "widgets-for-react";

type Props = {
  advert: RentalAdvert
  placeholderImage: SprocketAsset
  onTooltipToggle: () => void
  onCloseTooltip: () => void
  tooltipOpen: boolean
  mapType: ContentMapType
  setMapType: (t: ContentMapType) => void
  mapsIcon: SprocketAsset
  googleMapsKey: string
  locale: string
  routes: RoutesOutput<Routes>
  verifiedAspects: AsyncState<VerifiedAspect[]>
  setVerifiedAspects: (output: Action<AsyncState<VerifiedAspect[]>>) => void
}

export default (props: Props) : JSX.Element => {
  const translation = !!props.advert.translations ?
    Immutable.List(props.advert.translations.nodes).filter(x => x.locale == props.locale).first() :
    null
  return <>
    <CrumbTrail
      advert={props.advert}
      objectName={props.advert.objectName}
    />
    {
      props.advert.user.hasCoronaPolicy ?
        <CoronaPolicy
          link={props.routes.get('corona_policy_url')}
        /> :
        <></>
    }
    <hr/>
    <AdvertiserInfo
      user={props.advert.user}
      full_name={props.advert.advertiserFullName}
      user_placeholder={props.placeholderImage}
      tooltip_open={props.tooltipOpen}
      onTooltipToggle={() => props.onTooltipToggle()}
      onCloseTooltip={() => props.onCloseTooltip()}
      overviewPath={props.advert.user.rentalOverviewPath}
      verifiedAspects={props.verifiedAspects}
      setVerifiedAspects={props.setVerifiedAspects}
    />

    <Interior
      advert={props.advert}
      translation={translation}
    />

    <Surroundings
      advert={props.advert}
      mapType={props.mapType}
      setMapType={(m) => props.setMapType(m)}
      mapsIcon={props.mapsIcon}
      googleMapsKey={props.googleMapsKey}
      translation={translation}
    />

    <Skiing
      advert={props.advert}
      translation={translation}
    />

    <Culture
      advert={props.advert}
      translation={translation}
    />

    <Activities
      advert={props.advert}
      translation={translation}
    />

    <Remarks
      advert={props.advert}
      translation={translation}
    />

    {
      props.advert.user.allowYoutube
        ? <Youtube advert={props.advert} />
        : <></>
    }
    {
      props.advert.objectType == 'bed_and_breakfast' ?
        <div className="box" id="rooms">
          <h3>
            {I18n.t('bnb_rooms.title')}
          </h3>
          {
            props.advert.bnbRooms.nodes.map(bnb_room => (
              <BnbRoom
                room={bnb_room}
                translation={Immutable.List(bnb_room.translations.nodes).filter(x => x.locale == props.locale).first()}
              />
            ))
          }
        </div>
      : <></>
    }

    <PricingInfo
      advert={props.advert}
      translation={translation}
    />
  </>
}
